module.exports = __webpack_public_path__ + "static/media/aws_logo1.a6d98533.png";